import React, { createContext, useContext, type ReactNode } from "react";
import { useChatImpl, type UseChatReturn } from "@/features/ai-agent/hooks/useChat";

const CortexChatContext = createContext<UseChatReturn | undefined>(undefined);

export function CortexChatProvider({ children }: { children: ReactNode }) {
  const chat = useChatImpl();
  return (
    <CortexChatContext.Provider value={chat}>{children}</CortexChatContext.Provider>
  );
}

export function useCortexChat(): UseChatReturn {
  const context = useContext(CortexChatContext);
  if (context === undefined) {
    throw new Error("useCortexChat must be used within a CortexChatProvider");
  }
  return context;
}

/** @deprecated Prefer useCortexChat — kept for gradual migration. */
export function useChat(): UseChatReturn {
  return useCortexChat();
}
